module.exports = __webpack_public_path__ + "img/first-day-7.fdb5c66c.webp";